<div
  class="absolute top-0 left-0 h-full flex items-center justify-center flex-col gap-8 w-full bg-radial from-primary-400 to-primary-500 sm:from-transparent sm:to-transparent"
>
  <div
    class="flex flex-col sm:rounded-lg sm:shadow-[0_0_30px_rgba(0,0,0,0.2)] p-8 pb-4 bg-white/90 w-full max-w-xl justify-center items-center h-full sm:h-auto sm:min-h-[500px] gap-4"
  >
    <img
      src="logo_transparent_2_zeilig.webp"
      alt="Logo"
      class="w-2/3 sm:w-full sm:max-w-[320px] mb-2"
    />
    <div>
      <h1 class="text-2xl font-bold mb-4 text-primary-500" i18n>Sign in</h1>
    </div>
    <form
      (ngSubmit)="onLogin()"
      [formGroup]="form"
      class="flex items-center justify-center flex-col gap-8 min-w-[300px]"
    >
      <div class="flex flex-col gap-4 w-full">
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="far fa-user"></i>
          </p-inputgroup-addon>
          <input
            pInputText
            formControlName="username"
            placeholder="E-Mail or Username"
            autocomplete="username"
            autocapitalize="none"
            inputmode="username"
            type="text"
            i18n-placeholder
          />
        </p-inputgroup>

        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="far fa-key"></i>
          </p-inputgroup-addon>
          <p-iconfield>
            <input
              pInputText
              autocomplete="current-password"
              formControlName="password"
              placeholder="Password"
              [type]="passwordVisible ? 'text' : 'password'"
              i18n-placeholder
            />
            <p-inputicon
              [class]="passwordVisible ? 'far fa-eye' : 'far fa-eye-slash'"
              (click)="togglePasswordVisibility()"
            />
          </p-iconfield>
        </p-inputgroup>
      </div>
      <div>
        <p-button label="Sign in" type="submit" i18n-label></p-button>
      </div>
    </form>
    <span class="text-neutral-500 text-center text-sm">
      <span i18n>No account yet? </span>
      <a
        routerLink="/signup"
        i18n
        class="text-primary-500 underline underline-offset-2"
        >Register now</a
      >
      <i class="far fa-arrow-right text-neutral-500 ml-1"></i>
    </span>
    <small
      class="text-neutral-500 text-center flex flex-wrap items-center justify-center gap-x-4 gap-y-1 mt-8 sm:mt-4"
    >
      <a
        routerLink="/agb"
        class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2"
        i18n
      >
        Terms and Conditions
      </a>
      <span class="hidden sm:block"> | </span>
      <a
        routerLink="/privacy-policy"
        class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2"
        i18n
      >
        Privacy Policy
      </a>
      <span class="hidden sm:block"> | </span>

      <a
        href="https://www.lalino.eu/?page_id=112"
        class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2"
        i18n
      >
        Imprint
      </a>
      <button
        type="button"
        (click)="openWithdrawalDialog()"
        class="text-neutral-500 hover:text-primary-500 hover:underline underline-offset-2 bg-transparent border-0 p-0 cursor-pointer"
        i18n="@@withdrawal.open"
      >
        Cancel contract
      </button>
    </small>
  </div>
</div>
